require('./styles/style.scss');
export * from './scripts/main';

// if you wnat more or different stylesheets
// require('./styles/custom.scss');
